import { Component, Output, EventEmitter, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { ICheckoutStock } from '../../../../../../interfaces/checkout.interface';
import { calculateInvestment } from '../../../utils/investment-calculation';
import { OrderMarketEnum } from '@toro/common/shared/enum/orders/market.enum';
import { OrderMarketTypeEnum } from '@toro/common/shared/enum/orders/market-type.enum';

@Component({
    selector: 'chips-component',
    templateUrl: './chips.component.html',
    styleUrls: ['chips.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class ChipsComponent implements OnInit {

    @Output() public newLotValue   = new EventEmitter(); // Número de lotes que o cliente escolheu
    @Output() public newPriceValue = new EventEmitter(); // Valor de gain/loss que o cliente escolheu

    @Input() public stock: ICheckoutStock;
    @Input() public getInvestments: number; // Retorna o total que será investido pelo cliente
    @Input() public priceEdited: number; // Preço editado, quando vem da dialog de edição de preço
    @Input() public isPriceChip: boolean; // Tipo do chip, que poderá retornar o novo número de contratos ou novo preço
    public dayTradeStress: any;

    public minChip:    number = 1;
    public mediumChip: number = 5;
    public highChip:   number = 10;

    public constructor() {
    }

    public ngOnInit(): void {
        if (this.stock) {
            this.dayTradeStress = this.stock.isDayTrade ? this.stock.stress.dayTradeValue : 1;
        }
    }

    public chipValue(valueChip: number) {
        if (this.stock) {
            if (this.stock.typeMarket === OrderMarketTypeEnum.Future) {
                if (this.isPriceChip) {
                    return this.roundValue(valueChip * this.stock.priceStep * this.stock.lotDefault * this.stock.quoteFactor, 1);
                } else {
                    return this.roundValue(this.getInvestments / this.stock.buyAmount * valueChip, 1);
                }
            }

            if (this.stock.isDayTrade) {
                return this.roundValue(this.isPriceChip ? valueChip : this.getInvestments / this.stock.buyAmount * valueChip * this.stock.lotDefault, 1);
            } else {
                return this.roundValue(this.isPriceChip ? valueChip : this.stock.lotDefault * valueChip * this.stock.unitPrice, 1);
            }
        }
    }

    // Atualiza o número de lotes a investir, ou o preço de gain/loss
    public updateChip(value: number ) {
        this.isPriceChip ? this.updateValueScenario(value) : this.updateLotScenario(value);
    }

    // Cenário em que o cliente quer editar o número de contratos que quer operar
    public updateLotScenario(lot) {
        this.newLotValue.emit(lot * this.stock.lotDefault);
    }

    // Cenário em que o cliente quer editar o lucro/prejuízo do investimento
    public updateValueScenario(price) {
        this.newPriceValue.emit(this.roundValue(price * this.stock.priceStep * this.stock.lotDefault * this.stock.quoteFactor, 1));
    }

    public validateDisableChip(chipValue: number) {
        if (this.isPriceChip) {
            return this.priceEdited - chipValue <= 0 ? true : false;
        } else {
            return this.getInvestments - chipValue <= 0 ? true : false;
        }
    }

    public validateMaxAmount(chipValue: number) {
        if (this.isPriceChip) {
            return true;
        } else {
            if (this.stock.isFractionary) {
                return this.stock.buyAmount + chipValue < this.stock.mainLotDefault;
            } else {
                return true;
            }
        }
    }

    public roundValue(value, factor) {
        return Math.ceil(value / factor) * factor;
    }
}
